import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './body.module.css';

type Props = PropsWithChildren;

export function CompanyInformationBody({children}: Props) {
  return (
    <div
      className={clsx(
        styles.body,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {children}
    </div>
  );
}
